'use client';

import dynamic from 'next/dynamic';

const WindMap = dynamic(() => import('./WindMap'), {
  ssr: false,
  loading: () => <div className="bg-slate-800/50 rounded-xl h-[400px] animate-pulse" />,
});

export default function WindMapLazy() {
  return <WindMap />;
}
